import { render, staticRenderFns } from "./CrewsTable.vue?vue&type=template&id=5fbd65d2&scoped=true"
import script from "./CrewsTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./CrewsTable.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CrewsTable.vue?vue&type=style&index=0&id=5fbd65d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fbd65d2",
  null
  
)

export default component.exports